<mat-drawer-container hasBackdrop>
    <mat-drawer class="invoice-details" #drawer mode="over" position="end">
        <div fxLayout="row wrap" fxLayoutGap="8px" fxLayoutAlign="start center">
            <span fxFlex="40px"></span>
            <span
                    fxFlex
                    class="invoice-details-header"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_invoiceNumber }}</p>
			</span>
            <button
                    color="primary"
                    class="invoice-details-close-button"
                    fxFlex="nogrow"
                    mat-icon-button
                    (click)="drawer.close()"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-divider></mat-divider>

        <div fxLayout="row wrap" fxLayoutGap="2%" fxLayoutAlign="flex-start">
			<span fxFlex="100%" class="invoice-details-title">
				<h4>{{ 'global.provider'| translate}}</h4>
			</span>
            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_supplierParty_name "
            >
				<p>{{ 'global.name'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_supplierParty_name "
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_supplierParty_name }}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="!viewedInvoice?.processInstanceVariables?.invoice_supplierParty_name && viewedInvoice?.processInstanceVariables?.invoice_senderParty_name"
            >
				<p>{{ 'global.name'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-unresolved-value"
                    *ngIf="!viewedInvoice?.processInstanceVariables?.invoice_supplierParty_name && viewedInvoice?.processInstanceVariables?.invoice_senderParty_name"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_senderParty_name }}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_supplierParty_legalId "
            >
				<p>{{ 'global.legalID'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_supplierParty_legalId "
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_supplierParty_legalId  }}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_supplierParty_taxId"
            >
				<p>{{ 'global.taxIdentification'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_supplierParty_taxId"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_supplierParty_taxId}}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_supplierParty_contactElectronicMail"
            >
				<p>Contact</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_supplierParty_contactElectronicMail"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_supplierParty_contactElectronicMail }}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_supplierParty_financialAccount"
            >
				<p>{{ 'global.bankingInformation'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_supplierParty_financialAccount"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_supplierParty_financialAccount}}</p>
			</span>
        </div>

        <mat-divider></mat-divider>

        <div fxLayout="row wrap" fxLayoutGap="2%" fxLayoutAlign="flex-start">
			<span fxFlex="100%" class="invoice-details-title">
				<h4>{{ 'global.invoiceInformations'| translate}}</h4>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_issueDate"
            >
				<p>{{ 'global.issueDate'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_issueDate"
            >
				<p>{{ fixDateFormat(viewedInvoice?.processInstanceVariables?.invoice_issueDate) | date: 'mediumDate': '': translateService.currentLang}}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_dueDate"
            >
				<p>{{ 'global.dueDate'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_dueDate"
            >
				<p>{{ fixDateFormat(viewedInvoice?.processInstanceVariables?.invoice_dueDate) | date: 'mediumDate': '': translateService.currentLang}}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_receiptDate"
            >
				<p>{{'global.receptionDate' | translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_receiptDate"
            >
				<p>{{ fixDateFormat(viewedInvoice?.processInstanceVariables?.invoice_receiptDate) | date: 'mediumDate': '': translateService.currentLang}}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_invoiceNumber "
            >
				<p>{{ 'global.invoiceNumber'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_invoiceNumber">
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_invoiceNumber }}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_orderReference"
            >
				<p>{{'global.orderNo' | translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_orderReference"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_orderReference }}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_orderType"
            >
				<p>{{'global.orderType' | translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_orderType"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_orderType }}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_requesterDepartment"
            >
				<p>{{'global.requesterDepartment' | translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_requesterDepartment"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_requesterDepartment }}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_approverDepartment"
            >
				<p>{{'global.approverDepartment' | translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_approverDepartment"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_approverDepartment }}</p>
			</span>

            <span fxFlex="38%"
                  class="invoice-details-key"
                  *ngIf="viewedInvoice?.processInstanceVariables?.invoice_accountingDocumentNumber">
				<p>{{'global.accountingDocumentNumber' | translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_accountingDocumentNumber"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_accountingDocumentNumber }}</p>
			</span>

            <span fxFlex="38%"
                  class="invoice-details-key"
                  *ngIf="viewedInvoice?.processInstanceVariables?.invoice_accountingLabel">
				<p>{{'global.accountingLabel' | translate}}</p>
			</span>
            <span fxFlex="58%"
                  class="invoice-details-value"
                  *ngIf="viewedInvoice?.processInstanceVariables?.invoice_accountingLabel">
				<p>{{viewedInvoice?.processInstanceVariables?.invoice_accountingLabel}}</p>
			</span>


            <span fxFlex="38%"
                  class="invoice-details-key"
                  *ngIf="viewedInvoice?.processInstanceVariables?.invoice_note">
				<p>{{'global.note' | translate}}</p>
			</span>

            <span fxFlex="58%"
                  class="invoice-details-value"
                  *ngIf="viewedInvoice?.processInstanceVariables?.invoice_note">
				<p>{{viewedInvoice?.processInstanceVariables?.invoice_note}}</p>
			</span>

        </div>
        <mat-divider></mat-divider>
        <div fxLayout="row wrap" fxLayoutGap="2%" fxLayoutAlign="flex-start">
			<span fxFlex="100%" class="invoice-details-title">
				<h4>{{ 'global.amounts'| translate}}</h4>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_taxExclusiveAmount"
            >
				<p>{{ 'global.taxExclusiveAmount'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_taxExclusiveAmount"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_taxExclusiveAmount | number:'': translateService.currentLang}}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_taxAmount"
            >
				<p>{{ 'global.totalTaxes'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_taxAmount"
            >
				<p>{{viewedInvoice?.processInstanceVariables?.invoice_taxAmount | number:'': translateService.currentLang}}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_payableAmount"
            >
				<p>{{ 'global.payableAmount'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_payableAmount"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_payableAmount | number:'': translateService.currentLang}}</p>
			</span>

            <span
                    fxFlex="38%"
                    class="invoice-details-key"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_documentCurrencyCode"
            >
				<p>{{ 'global.documentCurrencyCode'| translate}}</p>
			</span>
            <span
                    fxFlex="58%"
                    class="invoice-details-value"
                    *ngIf="viewedInvoice?.processInstanceVariables?.invoice_documentCurrencyCode"
            >
				<p>{{ viewedInvoice?.processInstanceVariables?.invoice_documentCurrencyCode}}</p>
			</span>
        </div>
        <mat-divider></mat-divider>
        <div fxLayout="row wrap" fxLayoutGap="2%" fxLayoutAlign="flex-start">
            <span fxFlex></span>
            <button
                    mat-flat-button
                    color="primary"
                    fxFlex="nogrow"
                    class="invoice-details-download-button"
                    (click)="downloadAttachment(viewedInvoice?.processInstanceVariables?.invoice_invoiceStore_invoiceId)">
                {{'global.downloadDocument' | translate}}
            </button>
            <span fxFlex></span>
        </div>
    </mat-drawer>

    <mat-drawer-content>
        <mat-card class="mat-elevation-z0 mat-card-filters">
            <div fxLayout="row wrap" fxLayoutGap="4px" fxLayoutAlign="start center">
                <button
                        fxFlex="nogrow"
                        mat-icon-button
                        color="primary"
                        aria-label="Workspace home back button"
                        (click)="navigateToWorkspaceHome()"
                >
                    <mat-icon class="back-icon">arrow_back_ios</mat-icon>
                </button>
                <!--        <span fxFlex="20px"></span>-->
                <!--        <mat-slide-toggle fxFlex="nogrow" color="warn" (change)="onChange($event)"><span class="side-info">Factures non-->
                <!--            publiées</span></mat-slide-toggle>-->
                <span fxFlex></span>
                <span fxFlex>  {{'global.ongoingTaskPageTitle' | translate}} :
					<span class="filter-title">{{ numRows }}</span></span>
                <!--        <button class="explorer-action" mat-flat-button fxFlex=nogrow color="accent" [disabled]="!(unpublishedOnly)">-->
                <!--          <mat-icon class="button-icon">autorenew</mat-icon> PUBLIER (0)-->
                <!--        </button>-->
                <button
                        class="explorer-action"
                        mat-flat-button
                        fxFlex="nogrow"
                        color="primary"
                        [disabled]="isEmpty()"
                        (click)="onExport()"
                >
                    <mat-icon class="button-icon">save_alt</mat-icon>
                    {{'global.export' | translate}} ({{
                    selectionInvoice.selected.length
                    }})
                </button>
                <button *ngxPermissionsOnly="'explorer.ongoing.editor'"
                        class="explorer-action"
                        mat-stroked-button
                        fxFlex="nogrow"
                        color="warn"
                        [disabled]="isEmpty()"
                        (click)="onCancel()">
                    <mat-icon class="button-icon">block</mat-icon>
                    {{'global.cancel' | translate}} ({{selectionInvoice.selected.length}})
                </button>
                <button
                        class="explorer-action"
                        mat-stroked-button
                        fxFlex="nogrow"
                        color="primary"
                        (click)="openFilterDialog()"
                >
                    <mat-icon class="button-icon">filter_list
                    </mat-icon
                    >
                    {{ filters.length }}
                </button>
            </div>
        </mat-card>

        <mat-card class="mat-elevation-z2 mat-card-table">
            <mat-card-title></mat-card-title>
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="select" sticky>
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox
                                color="primary"
                                (change)="$event ? masterToggle() : null"
                                [checked]="selectionInvoice.hasValue() && isAllSelected()"
                                [indeterminate]="selectionInvoice.hasValue() && !isAllSelected()"
                        >
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox
                                color="primary"
                                (change)="$event ? selectionInvoice.toggle(row.id.toString()) : null"
                                [checked]="selectionInvoice.isSelected(row.id.toString())"
                        >
                        </mat-checkbox>
                    </td>
                </ng-container>

                <!-- Issue Date Column -->
                <ng-container matColumnDef="issueDate">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ 'global.issueDate'| translate}}
                    </th>
                    <td
                            mat-cell
                            *matCellDef="let element"
                            (click)="viewInvoiceOverview(element)"
                    >
                        {{ fixDateFormat(element.processInstanceVariables.invoice_issueDate) | date: 'shortDate': '': translateService.currentLang }}
                    </td>
                </ng-container>

                <!-- Supplier Column -->
                <ng-container matColumnDef="supplierParty.name">
                    <th mat-header-cell *matHeaderCellDef>{{ 'global.provider'| translate}}</th>
                    <ng-container *matCellDef="let element">

                        <td
                                mat-cell
                                (click)="viewInvoiceOverview(element)"
                                *ngIf="
						    element.processInstanceVariables.invoice_supplierParty_name;
						    else senderBlock
						    "
                        >
                            {{ element.processInstanceVariables.invoice_supplierParty_name }}
                        </td>
                        <ng-template #senderBlock>
                            <td mat-cell class="unresolved"
                                (click)="viewInvoiceOverview(element)">
                                {{ element.processInstanceVariables.invoice_senderParty_name }}
                            </td>
                        </ng-template>
                    </ng-container>
                </ng-container>

                <!-- Invoice Number Column -->
                <ng-container matColumnDef="invoiceNumber">
                    <th mat-header-cell *matHeaderCellDef>{{ 'global.invoiceNumber'| translate}}</th>
                    <td
                            mat-cell
                            *matCellDef="let element"
                            (click)="viewInvoiceOverview(element)"
                    >
                        {{ element.processInstanceVariables.invoice_invoiceNumber }}
                    </td>
                </ng-container>

                <!-- Total Amount Column -->
                <ng-container matColumnDef="taxExclusiveAmount">
                    <th mat-header-cell *matHeaderCellDef style="text-align: right">
                        {{ 'global.taxExclusiveAmount'| translate}}
                    </th>
                    <td
                            mat-cell
                            *matCellDef="let element"
                            (click)="viewInvoiceOverview(element)"
                            style="text-align: right"
                    >
                        {{ element.processInstanceVariables.invoice_taxExclusiveAmount | number:'1.2-2': translateService.currentLang }}
                    </td>
                </ng-container>

                <!-- Total Tax Column -->
                <ng-container matColumnDef="taxAmount">
                    <th mat-header-cell *matHeaderCellDef style="text-align: right">{{ 'global.taxAmount'| translate}}</th>
                    <td
                            mat-cell
                            *matCellDef="let element"
                            (click)="viewInvoiceOverview(element)"
                            style="text-align: right"
                    >
                        {{ element.processInstanceVariables.invoice_taxAmount | number:'1.2-2': translateService.currentLang}}
                    </td>
                </ng-container>

                <!-- Total Tax Column -->
                <ng-container matColumnDef="payableAmount">
                    <th mat-header-cell *matHeaderCellDef style="text-align: right">{{ 'global.payableAmount'| translate}}</th>
                    <td mat-cell
                        *matCellDef="let element"
                        (click)="viewInvoiceOverview(element)"
                        style="text-align: right">
                        {{ element.processInstanceVariables.invoice_payableAmount | number:'1.2-2': translateService.currentLang}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>{{ 'global.ongoingTask'| translate}}</th>
                    <td mat-cell
                        *matCellDef="let element"
                        (click)="viewInvoiceOverview(element)"
                    >
                        {{ element.name }}
                    </td>
                </ng-container>


                <tr mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"
                ></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <mat-paginator
                    [length]="dataSource.totalOperations$ | async"
                    [pageIndex]="0"
                    [pageSize]="20"
                    [pageSizeOptions]="[5, 10, 20, 50]"
                    showFirstLastButtons
            ></mat-paginator>
        </mat-card>
    </mat-drawer-content>
</mat-drawer-container>
